const brandName = "FilmoWatch";
export default brandName;